import React from "react";
import DatosDemograficos from '../../../containers/DatosDemograficos'
import { CAMPAIGN_2021 } from '../../../constants';

const EvacuadosPorProvincia = () => {
  return <DatosDemograficos campaign={CAMPAIGN_2021} year={2021}/>
};

export default EvacuadosPorProvincia;
